  
import React, { useState } from "react";
import { motion } from "framer-motion";
import PersonImage from "../Component/istockphoto-2050481773-612x612.jpg";  

const BusinessPromo = () => {
  const [showPopup, setShowPopup] = useState(false);

  const togglePopup = () => {
    setShowPopup(!showPopup);
  };

  return (
    <>
      <style>{`
        .containerss {
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: space-between;
          padding: 50px;
          font-family: Arial, sans-serif;
          height: auto;
          background-color:white;
          overflow: hidden;
          flex-wrap: wrap;
        }

        .text-sectiony {
          max-width: 50%;
          text-align: left;
        }

        .image-sectiony {
          display: flex;
          justify-content: flex-start;
          width: 50%;
        }

        .imagess {
          width: 100%;
          max-width: 681px;
          border-radius: 10px;
        }

        .headingyss {
          font-size: 36px;
          font-weight: bold;
          color: #0e7f9d;
          text-align:left;
        }

        .bold {
          color: #ffe124;
        }

        .paragraph {
          font-size: 17px;
          color: black;
          margin: 10px 0 20px;
          text-align:left;
          font-family: 'Poppins', sans-serif;
        }

        @media (max-width: 768px) {
          .containerss {
            flex-direction: column-reverse;
            height: auto;
          }

          .text-sectiony,
          .image-sectiony {
            max-width: 100%;
            width: 100%;
            text-align: center;
            justify-content: center;
          }

          .headingyss {
            font-size: 36px;
          }

          .imagess {
            max-width: 90%;
            margin: 0 auto;
          }
        }

        @media (max-width: 480px) {
          .headingyss {
            font-size: 30px;
          }

          .paragraph {
            font-size: 14px;
          }
        }
      `}</style>

      <div className="containerss">
        {/* Image Section - LEFT */}
        <motion.div
          className="image-sectiony"
          initial={{ opacity: 0, x: -50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 1, ease: "easeOut" }}
        >
          <img src={PersonImage} alt="NLP Representation" className="imagess" />
        </motion.div>

        {/* Text Section - RIGHT */}
        <motion.div
          className="text-sectiony"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, ease: "easeOut" }}
        >
          <p className="headingyss">
            Natural Language <span className="bold">Processing</span> <br />
          </p>

          <p className="paragraph">
            Unlock the power of human language with advanced Natural Language Processing 
            (NLP) solutions. Our expertise helps businesses bridge the gap between 
            unstructured text and actionable insights by enabling machines to understand, 
            interpret, and respond to human communication.
          </p>

          <p className="paragraph">
            From intelligent chatbots and virtual assistants to sentiment analysis, 
            text classification, and automated summarization, we deliver solutions that 
            make interactions smarter and more meaningful. NLP empowers your systems 
            to analyze customer conversations, extract knowledge, and enhance decision-making.
          </p>

          <p className="paragraph">
            Leveraging cutting-edge techniques like transformer-based models, deep learning, 
            and semantic search, our NLP services ensure accuracy, scalability, and adaptability 
            across multiple domains and languages.
          </p>

           
        </motion.div>
      </div>
    </>
  );
};

export default BusinessPromo;
